<!-- Practice Partner Table -->

<div *ngIf="!isEdit && !isAdd">
  <div class="container-fluid">

    <!-- Single white card: header row + table + empty state -->
    <div class="pp-card">

      <!-- Card header: title left · search + add button right -->
      <div class="pp-card-header">
        <h2 class="page-title">List of Practice Partners</h2>
        <div class="header-actions">
          <div class="search-wrapper">
            <input type="text"
                   class="search-input"
                   placeholder="Search for Partner..."
                   [(ngModel)]="searchText"
                   (keydown)="onKeydown($event)">
            <img src="assets/img/search.svg"
                 class="search-icon"
                 (click)="onKeydown($event)">
          </div>
          <button class="btn-create" (click)="addMember()">
            <i class="fa fa-plus me-2"></i> Add Practice Partner
          </button>
        </div>
      </div>

      <!-- Scrollable table -->
      <div *ngIf="members.length > 0" class="table-responsive-wrapper">
        <table class="head-table">
          <thead>
            <tr>
              <th>
                <div class="th-content">
                  <span>Name</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('name')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Email</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('email')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Phone</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('phone')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Designation</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('designation')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Specialist</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('practice')" alt="Sort">
                </div>
              </th>
              <th class="actions-col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of paginatedMembers | filter:searchText" class="table-row">
              <td>{{ member.name }}</td>
              <td>{{ member.email }}</td>
              <td>{{ member.phone }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.practice }}</td>
              <td class="action-cell">
                <button
                  mat-icon-button
                  class="action-btn"
                  [matMenuTriggerFor]="actionMenu"
                  [ngClass]="{'disabled': member.isdisabled}">
                  <span class="action-dots">&#8942;</span>
                </button>

                <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
                  <button mat-menu-item (click)="editMember(member)">Edit</button>
                  <button mat-menu-item (click)="deletePartner(member)">Delete</button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="nav-buttons" *ngIf="members.length > 10">
        <button class="prev" (click)="prev()" [disabled]="currentPage === 1">&lt;&lt; Prev</button>
        <button class="next" (click)="next()" [disabled]="currentPage === totalPages">Next &gt;&gt; </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="members && members?.length === 0" class="empty-state">
        No Practice Partners added.
      </div>

    </div><!-- /pp-card -->

  </div>
</div>
<!-- Practice Partner Table ends here -->


<!-- Edit Partner Data (completely unchanged) -->
<div *ngIf="isEdit">
  <!-- <div class="container-fluid">
    <div class="row" [ngStyle]="{'display':isDisplay?'block':'none'}">
      <div class="col-sm-12 compswitch">
        <div class="switch cswitch">
          <a href="javascript:void(0);" class="optionone compone" [routerLink]="['/profile']" [ngClass]="{'active': selectedMatter === 'basicprofile'}" (click)="onClick('basicprofile')">Basic Profile</a>
          <a href="javascript:void(0);" class="optiontwo comptwo" [ngClass]="{'active': selectedMatter === 'practicepartner'}" (click)="onClick('practicepartner')">Practice Partner</a>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Edit Practice Partner Form Card -->
  <form [formGroup]="myForm">
    <div class="form-page-wrapper">
      <div class="form-card">
        <div class="firm-head">
          <!-- <i class="fa fa-angle-left goback" aria-hidden="true" (click)="backToInfo()"></i>  -->
          Edit Practice Partner</div>

        <div class="form-grid">

          <!-- Name -->
          <div class="form-field">
            <label class="field-label">Name <span class="mandate">*</span></label>
            <input type="text"
                   formControlName="name"
                   [ngModel]="selectedMember?.name"
                   class="field-input"
                   name="name" />
            <div *ngIf="myForm.get('name').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('name').errors.required">This field is required</div>
            </div>
          </div>

          <!-- Specialist -->
          <div class="form-field">
            <label class="field-label">Specialist <span class="mandate">*</span></label>
            <input type="text"
                   class="field-input"
                   formControlName="practice"
                   [ngModel]="selectedMember?.practice"
                   name="practice" />
            <div *ngIf="myForm.get('practice').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('practice').errors.required">This field is required</div>
            </div>
          </div>

          <!-- Designation -->
          <div class="form-field">
            <label class="field-label">Designation <span class="mandate">*</span></label>
            <input type="text"
                   class="field-input"
                   formControlName="designation"
                   [ngModel]="selectedMember?.designation"
                   name="designation" />
            <div *ngIf="myForm.get('designation').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('designation').errors.required">This field is required</div>
            </div>
          </div>

          <!-- Phone Number -->
          <div class="form-field">
            <label class="field-label">Phone Number <span class="mandate">*</span></label>
            <input type="text"
                   class="field-input"
                   formControlName="phone"
                   [ngModel]="selectedMember?.phone"
                   maxlength="10"
                   name="phone" />
            <div *ngIf="myForm.get('phone').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('phone').errors.required">This field is required</div>
              <div *ngIf="myForm.get('phone').errors.pattern">Enter Valid Number</div>
              <div *ngIf="myForm.get('phone').errors.minlength || myForm.get('phone').errors.maxlength">Mobile number should be 10 digits</div>
            </div>
          </div>

          <!-- Email Address -->
          <div class="form-field email-field">
            <label class="field-label">Email Address <span class="mandate">*</span></label>
            <input type="email"
                   class="field-input"
                   formControlName="email"
                   [ngModel]="selectedMember?.email"
                   name="email" />
            <div *ngIf="myForm.get('email').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('email').errors.required">This field is required</div>
              <div *ngIf="myForm.get('email').errors.pattern">Invalid Email Address</div>
            </div>
          </div>

        </div>

        <!-- Divider + Action Buttons -->
        <div class="form-footer">
          <div class="footer-divider"></div>
          <div class="footer-actions">
            <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn-save" (click)="editPartner(member)">Save</button>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
<!-- Edit Partner Data ends here -->


<!-- Add Practice Partner (completely unchanged) -->
<div *ngIf="isAdd">
  <!-- <div class="container-fluid">
    <div class="row" [ngStyle]="{'display':isDisplay?'block':'none'}">
      <div class="col-sm-12 compswitch">
        <div class="switch cswitch">
          <a href="javascript:void(0);" class="optionone compone" [routerLink]="['/profile']" [ngClass]="{'active': selectedMatter === 'basicprofile'}" (click)="onClick('basicprofile')">Basic Profile</a>
          <a href="javascript:void(0);" class="optiontwo comptwo" [ngClass]="{'active': selectedMatter === 'practicepartner'}" (click)="onClick('practicepartner')">Practice Partner</a>
        </div>
      </div>
    </div> 
  </div> -->

  <!-- Add Practice Partner Form Card -->
  <form [formGroup]="myForm">
    <div class="form-page-wrapper">
      <div class="form-card">
        <div class="firm-head">
          <!-- <i class="fa fa-angle-left goback" aria-hidden="true" (click)="backToInfo()"></i>  -->
          Add Practice Partner
        </div>

        <div class="form-grid">

          <!-- Name -->
          <div class="form-field">
            <label class="field-label">Name <span class="mandate">*</span></label>
            <input type="text"
                   formControlName="name"
                   class="field-input"
                   name="name" />
            <div *ngIf="myForm.get('name').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('name').errors.required">This field is required</div>
            </div>
          </div>

          <!-- Specialist -->
          <div class="form-field">
            <label class="field-label">Specialist <span class="mandate">*</span></label>
            <input type="text"
                   class="field-input"
                   formControlName="practice"
                   name="practice" />
            <div *ngIf="myForm.get('practice').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('practice').errors.required">This field is required</div>
            </div>
          </div>

          <!-- Designation -->
          <div class="form-field">
            <label class="field-label">Designation <span class="mandate">*</span></label>
            <input type="text"
                   class="field-input"
                   formControlName="designation"
                   name="designation" />
            <div *ngIf="myForm.get('designation').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('designation').errors.required">This field is required</div>
            </div>
          </div>

          <!-- Phone Number -->
          <div class="form-field">
            <label class="field-label">Phone Number <span class="mandate">*</span></label>
            <input type="text"
                   class="field-input"
                   formControlName="phone"
                   maxlength="10"
                   name="phone" />
            <div *ngIf="myForm.get('phone').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('phone').errors.required">This field is required</div>
              <div *ngIf="myForm.get('phone').errors.pattern">Enter Valid Number</div>
              <div *ngIf="myForm.get('phone').errors.minlength || myForm.get('phone').errors.maxlength">Mobile number should be 10 digits</div>
            </div>
          </div>

          <!-- Email Address -->
          <div class="form-field email-field">
            <label class="field-label">Email Address <span class="mandate">*</span></label>
            <input type="email"
                   class="field-input"
                   formControlName="email"
                   name="email" />
            <div *ngIf="myForm.get('email').errors && submitted" class="errorStyle">
              <div *ngIf="myForm.get('email').errors.required">This field is required</div>
              <div *ngIf="myForm.get('email').errors.pattern">Invalid Email Address</div>
            </div>
          </div>

        </div>

        <!-- Divider + Action Buttons -->
        <div class="form-footer">
          <div class="footer-divider"></div>
          <div class="footer-actions">
            <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn-save" (click)="addPartner()">Save</button>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
<!-- Add Practice Partner ends here -->


<router-outlet></router-outlet>

<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>